import { useEffect, useRef } from 'react';

/** Modal simples com <dialog> nativo: foco, Esc e backdrop vêm de graça. */
export default function Dialogo({ titulo, aberto, aoFechar, children, largura = 460 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (aberto && !el.open) el.showModal();
    if (!aberto && el.open) el.close();
  }, [aberto]);

  return (
    <dialog ref={ref} className="dialogo" style={{ maxWidth: largura }} onCancel={aoFechar}>
      <header className="dialogo-cabecalho">
        <h2>{titulo}</h2>
        <button type="button" className="btn-fechar" onClick={aoFechar} aria-label="Fechar">
          ×
        </button>
      </header>
      {aberto && children}
    </dialog>
  );
}
